/// True while a run is in progress so offline/maintenance redirects wait.

import { create } from 'zustand';

interface GameSessionState {
  inGame: boolean;
  setActive: (inGame: boolean) => void;
}

export const useGameSessionStore = create<GameSessionState>((set) => ({
  inGame: false,
  setActive: (inGame) => set({ inGame }),
}));
